import React, { useState, useRef, useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import McpToolsOrder from './tools-order';
import VncViewer from '@/components/vnc-viewer/cards';
import { getMcpToolsConfig, McpToolsConfig } from '@shared/constants/mcp';
import ConnectionLine from '@/components/chat-history/connection-line';
import ConnectionLineStore from '@/components/chat-history/connection-line/store';
import "./index.scss";

const McpPanel = observer((props) => {
  const {
    mcpStore,
  } = props;
  const viewerRef = useRef(null);
  const viewerContainerRef = useRef(null);
  const {
    showSteps,
    currentPaneNode,
    currentPanelId,
    panelMessageId,
    currentTypingId,
    currentTypingNode,
    steps,
    chatStore,
    agentInfo,
  } = mcpStore;

  const config = getMcpToolsConfig(currentPaneNode);

  useEffect(() => {
    const handleScroll = () => {
      const id = `${panelMessageId || ''}_${currentPanelId || ''}`;
      ConnectionLineStore.updatePoint(id);
    }

    // 延迟200ms，确保dom已经渲染
    setTimeout(() => {
      handleScroll();
    }, 200);
    viewerRef.current?.addEventListener('scroll', handleScroll);
    // 监听viewerContainerRef的resize事件
    const resizeObserver = new ResizeObserver(handleScroll);
    resizeObserver.observe(viewerContainerRef.current);
    return () => {
      viewerRef.current?.removeEventListener('scroll', handleScroll);
      resizeObserver.disconnect();
    }
  }, [panelMessageId, currentPanelId, viewerContainerRef.current]);

  return (
    <div className="mcp-panel z-0 size-full flex flex-col relative">
      {
        HelperCore.isPhone() ? (
          <div className="relative z-2 h-72px min-h-72px flex justify-between items-center px-25px  border-bottom-1px border-black border-opacity-10">
            <div 
              className='size-32px cursor-pointer hover:bg-black hover:bg-opacity-3 rounded-8px flex items-center justify-center' 
              onClick={mcpStore.toggleShowRightPanel}
              >
              <SVGPureIcon 
                name="mcp_panel_fold" 
                className='size-24px'
                />
            </div>
          </div>
        ) : null
      }

      <div id='vncviewer' ref={viewerRef} className="pl-48px pr-40px mr-4px flex-grow nw-scrollbar-thin overflow-x-hidden overflow-y-auto relative">
        <div ref={viewerContainerRef}>
          <VncViewer  refView={viewerRef} refViewContainer={viewerContainerRef} />
        </div>
      </div>
      {/* 连接线 */}
      {currentPanelId && panelMessageId && !HelperCore.isPhone() ? <ConnectionLine/> : null}
    </div>
  )
});
export default McpPanel;